import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  Select,
  Pagination,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  can,
} from "../../components/CustomComponent.js";
import { NEARBY_TYPES } from "../../components/asset_option.js";
import {
  MAP_KEY,
  MAP_LIBRARIES,
  MAP_CENTER_DEFAULT,
  MAP_CONTAINER_STYLE,
  MAP_OPTIONS,
  reverseGeocode,
  zoneOptions,
  nearestStations,
  coord,
  fullAddress,
} from "../../components/location_option.js";
/* ตัวช่วยฝั่ง "ข้อมูลโครงการ" — ชุดเดียวกับที่ฟอร์มเพิ่มทรัพย์ใช้ (page/admin/asset_create.js)
   ทั้งสองหน้าต้องตัดสินเรื่องเดียวกัน : สถานที่ที่ค้นจากแผนที่มีในข้อมูลโครงการแล้วหรือยัง */
import {
  normalizeName,
  findProjectByName,
  projectLocationBody,
  textOrDash,
} from "../../components/project_option.js";
import PlaceSearch from "../../components/PlaceSearch.js";
import { GoogleMap, LoadScriptNext, Marker } from "@react-google-maps/api";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_form.css";
import "../../assets/css/property_type.css";

/* ============================================================================
 * จัดการทรัพย์ › โครงการ  (/ad/projects)
 *
 * ข้อมูล master ของทำเล — 1 โครงการเก็บชื่อ + ชุด "ตำแหน่งที่ตั้ง" ชุดเดียวกับ
 * ขั้นที่ 1 ของฟอร์มเพิ่มทรัพย์ (จังหวัด / เขต / แขวง / ซอย / รหัสไปรษณีย์ / พิกัด /
 * จุดสนใจใกล้เคียง) พอเลือกโครงการในฟอร์มเพิ่มทรัพย์ ระบบจะเติมค่าทั้งชุดให้อัตโนมัติ
 * ไม่ต้องกรอกทำเลซ้ำทุกยูนิตในโครงการเดียวกัน
 *
 * แต่ละโครงการผูก "ประเภททรัพย์" ได้หลายประเภท (โครงการมิกซ์ยูสมีทั้งคอนโดและทาวน์โฮม)
 * ฟอร์มเพิ่มทรัพย์ใช้ชุดนี้กรองตัวเลือกโครงการให้เหลือเฉพาะโครงการที่มีประเภทที่เลือกไว้
 *
 * ต่อกับ API แล้ว :
 *   GET    admin/asset-categories (ประเภททรัพย์ — ตัวเลือกของฟอร์ม)
 *   GET    admin/projects        (Get — ค้นหา/กรอง/แบ่งหน้าที่ฝั่ง API)
 *   POST   admin/projects        (Save — สร้าง)
 *   PUT    admin/projects/:uid   (Save — แก้ไข / ToggleActive)
 *   DELETE admin/projects/:uid   (Delete — ลบไม่ได้ถ้ายังมีทรัพย์ผูกอยู่)
 * ========================================================================== */

const PAGE_SIZE = 10;

/* ตัวกรองของหน้า — คีย์ตรงกับ query ที่ project.service อ่าน (ดูเมธอด query) */
const EMPTY_FILTER = {
  keyword: "",
  category: "", // uid ของประเภททรัพย์ (ว่าง = ทุกประเภท)
};

const EMPTY_FORM = {
  name: "",
  name_en: "",
  description: "",
  place_search: "",
  province: "",
  district: "",
  subdistrict: "",
  soi: "",
  postcode: "",
  latitude: "",
  longitude: "",
  nearby: [],
  asset_category_uids: [], // ประเภททรัพย์ที่โครงการนี้มี (uid ของ asset_categories)
  extra_categories: [], // ประเภทที่ผูกไว้แต่ถูกปิดใช้งานแล้ว — โชว์ให้เห็นเพื่อให้ถอดออกได้
  is_active: true,
};

/* ---------------------------------------------------------------- ตัวช่วย */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");
const num = (value) => Number(value || 0).toLocaleString("en-US");
const digits = (v) => /^[\d.]*$/.test(v);
const signedDigits = (v) => /^-?[\d.]*$/.test(v);
// ค่าจาก API เป็นตัวเลข/null แต่ช่อง input ต้องได้สตริงเสมอ ไม่งั้น React จะเปลี่ยนเป็น uncontrolled
const str = (value) => (value === null || value === undefined ? "" : String(value));

const displayName = (item) => (isTh() ? item.name : item.name_en || item.name);

/* ชื่อประเภททรัพย์ตามภาษาที่เลือก — ข้อมูล master เก็บ name_th / name_en แยกกัน */
const categoryName = (category) => (category ? (isTh() ? category.name_th : category.name_en || category.name_th) : "");

export default class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [], // โครงการของหน้าปัจจุบันเท่านั้น (แบ่งหน้าที่ฝั่ง API)
      categories: [], // ประเภททรัพย์ (ข้อมูล master จาก API — ใช้เป็นตัวเลือกในฟอร์ม)
      count: 0, // จำนวนโครงการทั้งหมดที่ตรงตัวกรองปัจจุบัน
      active_count: 0, // ในจำนวนนั้นเปิดใช้งานอยู่กี่โครงการ
      page: 1,

      filter: { ...EMPTY_FILTER }, // ตัวกรองในฟอร์ม (ยังไม่กดค้นหา)
      applied: { ...EMPTY_FILTER }, // ตัวกรองที่ใช้กับผลลัพธ์ชุดที่แสดงอยู่

      modal_form: false,
      edit_uid: "", // ว่าง = โหมดเพิ่มโครงการใหม่
      form: { ...EMPTY_FORM },
      /* โครงการเดิมที่ตรงกับสถานที่ที่เพิ่งค้นจากแผนที่ (null = ไม่ตรงกับอันไหน)
         { uid, name, switched } — switched = ฟอร์มถูกสลับจาก "เพิ่ม" มาเป็น "แก้ไข" ให้อัตโนมัติ */
      matched_project: null,

      // Google Maps JS API โหลดเสร็จหรือยัง (ใช้ตัดสินใจว่าเรียก Geocoder ได้ไหม)
      map_ready: !!window.google?.maps,
    };
  }

  componentDidMount() {
    loading(false);
    this.GetMaster();
    this.Get(1);
  }

  /* ประเภททรัพย์ — ตัวเลือกของฟอร์ม (เอาเฉพาะที่เปิดใช้งานอยู่ เหมือนฟอร์มเพิ่มทรัพย์) */
  GetMaster = async () => {
    const result = await GET("admin/asset-categories", { page: 0, is_active: true });
    if (!result?.status) return;

    this.setState({ categories: result.data || [] });
  };

  /* ------------------------------------------------------- ดึงรายการโครงการ */
  /**
   * แปลงตัวกรองในหน้าเป็น query ของ API — คีย์ตรงกับที่ project.service อ่าน
   *
   * ต้องตัดคีย์ที่ไม่มีค่าออกก่อนส่ง เพราะ buildUrl ของ services/api.js ต่อ "ทุกคีย์"
   * ที่ส่งเข้าไปเป็น query string ค่าว่างจึงวิ่งไปถึงตัวกรองฝั่ง backend โดยไม่ตั้งใจ
   */
  query = (page, filter, extra = {}) => {
    const params = {
      page,
      page_size: PAGE_SIZE,
      data_search: filter.keyword,
      asset_category_uid: filter.category,
      ...extra,
    };

    return Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)
    );
  };

  Get = async (page = this.state.page, filter = this.state.applied) => {
    loading(true);
    /* ป้ายจำนวน "เปิดใช้งาน" นับจากตัวกรองชุดเดียวกับตาราง — ต้องการแค่ pagination.count
       จึงส่ง page_size: 1 ไปพอ ไม่ต้องดึงแถวจริงมาทั้งชุด */
    const [result, active] = await Promise.all([
      GET("admin/projects", this.query(page, filter)),
      GET("admin/projects", this.query(1, filter, { page_size: 1, is_active: "true" })),
    ]);
    loading(false);

    if (!result?.status) return;

    const rows = result.data || [];

    // ลบรายการสุดท้ายของหน้าแล้วหน้านั้นว่าง — ถอยไปหน้าก่อนหน้าให้อัตโนมัติ
    if (!rows.length && page > 1) return this.Get(page - 1, filter);

    this.setState({
      items: rows,
      count: result.pagination?.count ?? rows.length,
      active_count: active?.status ? active.pagination?.count || 0 : 0,
      page,
      // ตัวกรองที่ "ใช้กับผลลัพธ์ชุดนี้จริง ๆ" — เปลี่ยนหน้าทีหลังจะได้ยึดชุดนี้
      // ไม่ใช่ชุดที่ผู้ใช้พิมพ์ค้างไว้ในฟอร์มแต่ยังไม่ได้กดค้นหา
      applied: { ...filter },
    });
  };

  /* -------------------------------------------------------------- ตัวกรอง */
  /* แก้ค่าในฟอร์มเฉย ๆ ยังไม่ยิง API — ผลลัพธ์เปลี่ยนตอนกดปุ่มค้นหาเท่านั้น */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  Search = () => this.Get(1, this.state.filter);

  clearFilters = () => this.setState({ filter: { ...EMPTY_FILTER } }, () => this.Get(1, { ...EMPTY_FILTER }));

  // มีเงื่อนไขค้างอยู่ไหม — ใช้เลือกข้อความตอนไม่พบข้อมูล (ยังไม่มีโครงการ vs หาไม่เจอ)
  hasFilter = () => Object.values(this.state.applied).some((value) => value !== "");

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* --------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ไข */
  OpenCreate = () =>
    this.setState({
      modal_form: true,
      edit_uid: "",
      matched_project: null,
      form: { ...EMPTY_FORM },
    });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      matched_project: null,
      form: {
        ...EMPTY_FORM,
        name: item.name || "",
        name_en: item.name_en || "",
        description: item.description || "",
        place_search: item.name || "",
        province: item.province || "",
        district: item.district || "",
        subdistrict: item.subdistrict || "",
        soi: item.soi || "",
        postcode: item.postcode || "",
        latitude: str(item.latitude),
        longitude: str(item.longitude),
        nearby: (item.nearby || []).map((e) => ({ type: e.type || "other", label: e.label || "", distance: str(e.distance) })),
        asset_category_uids: [...(item.asset_category_uids || [])],
        /* ประเภทที่โครงการนี้ผูกไว้แต่ถูกปิดใช้งานไปแล้ว — ตัวเลือกในฟอร์มมีแต่ประเภทที่เปิดใช้งาน
           ถ้าไม่พ่วงมาด้วย ผู้ใช้จะเห็นแค่ปุ่มที่กดค้างหายไปเฉย ๆ ทั้งที่ค่ายังผูกอยู่ */
        extra_categories: (item.asset_categories || []).filter((e) => !this.state.categories.some((c) => c.uid === e.uid)),
        is_active: !!item.is_active,
      },
    });

  CloseForm = () => this.setState({ modal_form: false, matched_project: null });

  /* ------------------------------------------------------- ประเภททรัพย์ */
  // กดซ้ำ = เอาออก โครงการหนึ่งผูกได้หลายประเภท จึงเป็นการเลือกแบบสลับเปิด/ปิดทีละอัน
  toggleCategory = (uid) =>
    this.setForm({
      asset_category_uids: this.state.form.asset_category_uids.includes(uid)
        ? this.state.form.asset_category_uids.filter((value) => value !== uid)
        : [...this.state.form.asset_category_uids, uid],
    });

  /* ------------------------------------------------------------- ทำเล / แผนที่ */
  // เปลี่ยนจังหวัด/เขต/แขวง → ล้างค่าที่ผูกอยู่ระดับล่างลงไป แล้วเติมรหัสไปรษณีย์ให้
  setProvince = (province) => this.setForm({ province, district: "", subdistrict: "", postcode: "" });

  setDistrict = (district) => this.setForm({ district, subdistrict: "", postcode: "" });

  setSubdistrict = (subdistrict, option) => this.setForm({ subdistrict, postcode: option?.code ? String(option.code) : "" });

  /* ต้องเป็นเมธอดของคลาส ห้ามส่ง arrow function ใหม่เข้าไปตรง prop onLoad
     เพราะ LoadScriptNext เรียก onLoad ผ่าน useEffect ที่มี onLoad เป็น dependency
     ถ้า identity เปลี่ยนทุก render มันจะเรียกซ้ำจนได้ "Maximum update depth exceeded" */
  MapLoaded = () => {
    if (!this.state.map_ready) this.setState({ map_ready: true });
  };

  // คืน object เดิมตราบใดที่พิกัดไม่เปลี่ยน เพราะ GoogleMap จะ setCenter ใหม่ทุกครั้ง
  // ที่ prop center เปลี่ยน reference (ถ้าสร้างใหม่ทุก render แผนที่จะเด้งกลับตลอด)
  pinned = () => {
    const lat = coord(this.state.form.latitude);
    const lng = coord(this.state.form.longitude);
    if (lat === null || lng === null) return null;
    if (!this.pin_cache || this.pin_cache.lat !== lat || this.pin_cache.lng !== lng) this.pin_cache = { lat, lng };
    return this.pin_cache;
  };

  // คลิก (หรือลาก marker) บนแผนที่ → เติมพิกัดลงช่อง input แล้วดึงที่อยู่มาเติมให้
  PinMap = (event) => {
    const lat = event?.latLng?.lat();
    const lng = event?.latLng?.lng();
    if (lat === undefined || lng === undefined) return;
    this.setForm({ latitude: lat.toFixed(6), longitude: lng.toFixed(6) });
    this.FillAddress({ lat, lng });
  };

  /* reverse geocode : พิกัด → จังหวัด/เขต/แขวง/รหัสไปรษณีย์
     ส่วนที่จับคู่กับ th_province.json ไม่ได้จะคงค่าเดิมไว้ (ไม่ล้างของที่ผู้ใช้กรอกเอง)
     แต่ต้องบอกผู้ใช้ด้วย ไม่งั้นหมุดขยับแล้วช่องที่อยู่ไม่เปลี่ยน จะนึกว่าระบบค้าง */
  FillAddress = async (location) => {
    if (!this.state.map_ready || !window.google?.maps) return;

    const { zone, error } = await reverseGeocode(location);
    if (error) return alert("", "warning", t("warning"), t(error));
    if (!zone) return alert("", "warning", t("warning"), t("address_out_of_range"));

    this.setForm(zone);
  };

  /* เลือกสถานที่จากรายการแนะนำ → ย้ายหมุด + เติมทำเลรวดเดียว
     Places คืน addressComponents มาให้อยู่แล้ว จึงไม่ต้องยิง Geocoding ซ้ำ */
  PickPlace = ({ lat, lng, zone, name }) => {
    this.setForm({ latitude: lat.toFixed(6), longitude: lng.toFixed(6), ...(zone || {}) });
    if (!zone) alert("", "warning", t("warning"), t("address_out_of_range"));
    this.MatchProject(name);
  };

  /* ------------------------------------------------- จับคู่กับโครงการที่มีอยู่
   * ค้นหาตำแหน่งที่ตั้งจากแผนที่แล้ว ต้องเช็กด้วยว่าสถานที่นั้นมีในข้อมูลโครงการหรือยัง
   *   ยังไม่มี → เติมชื่อโครงการให้จากชื่อสถานที่ แล้วบันทึกเป็นโครงการใหม่ตามปกติ
   *   มีแล้ว   → สลับฟอร์มเป็นการ "แก้ไขโครงการเดิม" ให้อัตโนมัติ (ชื่อโครงการห้ามซ้ำ
   *              กรอกต่อแล้วบันทึกจะได้เป็นการอัปเดต ไม่ใช่เด้งว่าชื่อซ้ำตอนกดบันทึก)
   * (ฟอร์มเพิ่มทรัพย์ทำแบบเดียวกัน — page/admin/asset_create.js › MatchProject)
   * ---------------------------------------------------------------------- */
  MatchProject = async (placeName) => {
    const name = normalizeName(placeName || this.state.form.place_search);
    if (!name) return;

    const project = await findProjectByName(name);
    const { edit_uid, form } = this.state;

    if (!project) {
      this.setState({ matched_project: null });
      // ยังไม่ได้ตั้งชื่อ = เอาชื่อสถานที่มาเติมให้ (ที่ผู้ใช้พิมพ์เองไว้แล้วห้ามทับ)
      if (!normalizeName(form.name)) this.setForm({ name });
      return;
    }

    // กำลังแก้โครงการอื่นค้างอยู่ — สลับให้ไม่ได้ (จะกลายเป็นแก้คนละตัวกับที่เปิดมา) บอกให้รู้พอ
    if (edit_uid && edit_uid !== project.uid) {
      this.setState({ matched_project: { uid: project.uid, name: project.name, switched: false } });
      return;
    }
    // ค้นเจอโครงการเดียวกับที่กำลังแก้อยู่ = ไม่มีอะไรต้องบอก
    if (edit_uid === project.uid) return this.setState({ matched_project: null });

    /* สลับมาเป็นการแก้ไขโครงการเดิม — ค่าที่ผู้ใช้พิมพ์ค้างไว้ถือว่าใหม่กว่า จึงคงไว้ก่อน
       ช่องไหนยังว่างค่อยเอาของเดิมในระบบมาเติม ส่วนตำแหน่งที่ตั้งใช้หมุดที่เพิ่งปักใหม่ */
    this.setState({
      edit_uid: project.uid,
      matched_project: { uid: project.uid, name: project.name, switched: true },
      form: {
        ...form,
        name: project.name,
        name_en: form.name_en || project.name_en || "",
        description: form.description || project.description || "",
        nearby: form.nearby.length
          ? form.nearby
          : (project.nearby || []).map((e) => ({ type: e.type || "other", label: e.label || "", distance: str(e.distance) })),
        // ประเภทที่ติ๊กค้างไว้ต้องไม่หาย และของเดิมในระบบก็ต้องไม่ถูกถอดออกโดยไม่ตั้งใจ
        asset_category_uids: [...new Set([...form.asset_category_uids, ...(project.asset_category_uids || [])])],
        extra_categories: (project.asset_categories || []).filter((e) => !this.state.categories.some((c) => c.uid === e.uid)),
        is_active: !!project.is_active,
      },
    });
  };

  /* กดยกเลิกบนป้าย = กลับไปเป็นการเพิ่มโครงการใหม่ (ค่าที่กรอกไว้คงเดิม ตั้งชื่อใหม่แล้วบันทึกต่อได้)
     ใช้ได้เฉพาะฟอร์มที่ถูกสลับมาให้อัตโนมัติ ไม่งั้นจะกลายเป็นเปลี่ยนการแก้ไขจริง ๆ เป็นการเพิ่มใหม่ */
  UnmatchProject = () => this.setState({ edit_uid: "", matched_project: null });

  /* ------------------------------------------------- จุดสนใจใกล้เคียง */
  FillStations = () => {
    const pin = this.pinned();
    if (!pin) {
      alert("", "warning", t("warning"), t("nearby_need_pin"));
      return;
    }

    const added = nearestStations(pin, this.state.form.nearby);
    if (!added.length) {
      alert("", "warning", t("warning"), t("nearby_no_station"));
      return;
    }

    this.setForm({ nearby: [...this.state.form.nearby, ...added] });
    alert("", "success", t("success"), t("nearby_station_added").replace("{count}", added.length));
  };

  setNearby = (index, patch) =>
    this.setForm({ nearby: this.state.form.nearby.map((item, i) => (i === index ? { ...item, ...patch } : item)) });

  AddNearby = () => this.setForm({ nearby: [...this.state.form.nearby, { type: "mall", label: "", distance: "" }] });

  RemoveNearby = (index) => this.setForm({ nearby: this.state.form.nearby.filter((_, i) => i !== index) });

  /* ------------------------------------------------------------ บันทึกข้อมูล */
  Save = async () => {
    const { form, edit_uid } = this.state;
    const name = normalizeName(form.name);

    if (!name) return alert("", "warning", t("warning"), t("project_verify_name"));
    if (!form.province || !form.district || !form.subdistrict)
      return alert("", "warning", t("warning"), t("verify_location"));
    /* ต้องมีอย่างน้อย 1 ประเภท เพราะฟอร์มเพิ่มทรัพย์กรองโครงการด้วยประเภทที่เลือก
       โครงการที่ไม่ได้ผูกประเภทไว้จะโผล่ในทุกประเภท (เผื่อข้อมูลเก่าที่ยังไม่ได้ระบุ) */
    if (!form.asset_category_uids.length)
      return alert("", "warning", t("warning"), t("project_verify_category"));

    loading(true);
    const match = await findProjectByName(name);
    loading(false);

    /* ชื่อนี้มีโครงการอยู่แล้ว (ชื่อโครงการห้ามซ้ำ — unique index ฝั่งฐานข้อมูลกันไว้อีกชั้น)
         กำลังเพิ่มใหม่      → ไม่สร้างซ้ำ แต่เสนออัปเดตโครงการเดิมให้แทน
         กำลังแก้โครงการอื่น → เปลี่ยนชื่อไปทับตัวอื่นไม่ได้ ต้องเตือนให้ตั้งชื่ออื่น */
    const conflict = !!match && match.uid !== edit_uid;
    if (conflict && edit_uid) return alert("", "warning", t("warning"), t("project_verify_name_duplicate"));

    // ปลายทางที่จะบันทึกลง — ว่าง = สร้างใหม่
    const target = conflict ? match.uid : edit_uid;

    const confirmed = conflict
      ? await alert("", "info", t("project_update_existing"), t("project_update_existing_desc").replace("{name}", match.name), t("confirm"), t("cancel"))
      : await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"));
    if (!confirmed) return;

    const body = {
      name,
      name_en: textOrDash(form.name_en),
      description: textOrDash(form.description),
      ...projectLocationBody(form),
      /* อัปเดตทับโครงการเดิมที่ไม่ได้เปิดมาแก้ — ประเภทที่โครงการนั้นผูกไว้อยู่ต้องไม่หลุด
         เพราะฟอร์มชุดนี้ตั้งค่ามาสำหรับโครงการใหม่ ไม่ได้เห็นของเดิมมาก่อน */
      asset_category_uids: conflict
        ? [...new Set([...form.asset_category_uids, ...(match.asset_category_uids || [])])]
        : form.asset_category_uids,
      is_active: form.is_active,
    };

    loading(true);
    const result = !target ? await POST("admin/projects", body) : await PUT("admin/projects/" + target, body);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false, matched_project: null });
    // เพิ่มใหม่ = กลับไปหน้าแรก (เรียงตามชื่อ โครงการใหม่จึงไม่จำเป็นต้องอยู่หน้าที่ค้างไว้)
    await this.Get(target ? this.state.page : 1);
    alert("", "success", t("success"), target ? t("save_done") : t("project_add_done"));
  };

  /* -------------------------------------------------------- เปิด/ปิดใช้งาน */
  ToggleActive = async (item) => {
    const next = !item.is_active;
    const detail = next ? t("project_enable_confirm") : t("project_disable_confirm");
    if (!(await alert("", "info", next ? t("project_enable") : t("project_disable"), `${detail}\n${displayName(item)}`, t("confirm"), t("cancel"))))
      return;

    loading(true);
    const result = await PUT("admin/projects/" + item.uid, { is_active: next });
    loading(false);

    if (!result?.status) return;

    await this.Get();
    alert("", "success", t("success"), next ? t("project_enable_done") : t("project_disable_done"));
  };

  /* ------------------------------------------------------------------- ลบ */
  Delete = async (item) => {
    // ทรัพย์ที่ผูกอยู่จะกลายเป็นทรัพย์ที่ชี้โครงการที่ไม่มีจริง — กันไว้ตั้งแต่หน้าเว็บ
    if (item.asset_count) {
      return alert("", "warning", t("warning"), t("project_delete_in_use").replace("{count}", num(item.asset_count)));
    }
    if (!(await alert("", "warning", t("delete_item"), `${t("project_delete_desc")}\n${displayName(item)}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE("admin/projects/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false });
    await this.Get();
    alert("", "success", t("success"), t("delete_done"));
  };

  /* ==================================================== render : ชิ้นส่วนย่อย */
  input = (key, label, options = {}) => {
    const { placeholder, required, numeric, maxLength } = options;
    return (
      <>
        <label className="prop-label">
          {t(label)}
          {required && <span className="pf-req">*</span>}
        </label>
        <input
          type="text"
          className="prop-field"
          placeholder={placeholder ? t(placeholder) : ""}
          value={this.state.form[key]}
          maxLength={maxLength}
          onChange={(e) => (!numeric || (numeric === "signed" ? signedDigits : digits)(e.target.value)) && this.setForm({ [key]: e.target.value })}
        />
      </>
    );
  };

  select = (key, label, options, extra = {}) => (
    <>
      <label className="prop-label">
        {t(label)}
        {extra.required && <span className="pf-req">*</span>}
      </label>
      <Select
        className="prop-field prop-select"
        default={false}
        placeholder={extra.placeholder ? t(extra.placeholder) : t("please_select")}
        value={this.state.form[key]}
        options={options}
        disabled={extra.disabled}
        onChange={(value, option) => (extra.onChange ? extra.onChange(value, option) : this.setForm({ [key]: value }))}
      />
    </>
  );

  /* ประเภททรัพย์ของโครงการ — เลือกได้หลายอัน กดปุ่มเดิมซ้ำเพื่อเอาออก */
  renderCategories = () => {
    const { form, categories } = this.state;
    const options = [...categories, ...form.extra_categories];

    return (
      <div className="pf-section">
        <label className="prop-label">
          {t("property_type")}
          <span className="pf-req">*</span>
        </label>

        {options.length ? (
          <div className="pf-typegrid">
            {options.map((category) => {
              const on = form.asset_category_uids.includes(category.uid);
              return (
                <button
                  key={category.uid}
                  type="button"
                  aria-pressed={on}
                  className={`pf-type ${on ? "is-active" : ""}`}
                  onClick={() => this.toggleCategory(category.uid)}
                >
                  <span className="icon">{category.icon}</span>
                  <span>{categoryName(category)}</span>
                </button>
              );
            })}
          </div>
        ) : (
          <div className="pf-doc pf-doc--empty">
            <span className="text-12 text-secondary">{t("project_category_empty")}</span>
          </div>
        )}

        <div className="pf-hint">{t("project_category_hint")}</div>
      </div>
    );
  };

  /* ป้ายบอกผลการจับคู่ชื่อโครงการจากการค้นหาบนแผนที่ — ต้องเห็นตั้งแต่ตอนค้น
     ไม่ใช่ไปเจอตอนกดบันทึกแล้วเด้งว่าชื่อซ้ำ */
  renderMatchNote = () => {
    const match = this.state.matched_project;
    if (!match) return null;

    return (
      <div className={`pf-note mt-2 ${match.switched ? "pf-note--info" : ""}`}>
        <span className="icon">{"\uf05a"}</span>
        <div className="flex-grow-1">{t(match.switched ? "project_match_switched" : "project_match_other").replace("{name}", match.name)}</div>
        {match.switched && (
          <button type="button" className="pf-note__x icon" title={t("cancel")} onClick={this.UnmatchProject}>
            {"\uf00d"}
          </button>
        )}
      </div>
    );
  };

  renderMap = () => {
    const { form } = this.state;
    const pin = this.pinned();

    if (!MAP_KEY) {
      return (
        <div className="pf-map pf-map--empty">
          <span className="icon text-18 mb-2">{""}</span>
          <span className="text-12">{t("map_key_missing")}</span>
        </div>
      );
    }

    return (
      <div className="pf-map">
        <LoadScriptNext
          googleMapsApiKey={MAP_KEY}
          libraries={MAP_LIBRARIES}
          language="th"
          region="TH"
          loadingElement={<div className="pf-map__loading">{t("map_loading")}</div>}
          onLoad={this.MapLoaded}
        >
          <GoogleMap mapContainerStyle={MAP_CONTAINER_STYLE} center={pin || MAP_CENTER_DEFAULT} zoom={pin ? 16 : 11} options={MAP_OPTIONS} onClick={this.PinMap}>
            {pin && <Marker position={pin} draggable onDragEnd={this.PinMap} />}
          </GoogleMap>
        </LoadScriptNext>
        <span className="pf-map__badge">{pin ? `${form.subdistrict || "-"} · ${form.district || "-"}` : t("map_no_pin")}</span>
      </div>
    );
  };

  renderNearby = () => {
    const list = this.state.form.nearby || [];

    return (
      <div className="pf-section">
        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
          <div className="pf-subtitle mb-0">
            <span className="icon">{""}</span>
            {t("nearby_places")}
          </div>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.FillStations}>
            <span className="icon text-12">{""}</span>
            {t("nearby_fill_station")}
          </button>
        </div>

        <div className="pf-doclist mt-2">
          {list.map((item, index) => (
            <div key={index} className="pf-doc">
              <div className="row g-2 flex-grow-1" style={{ minWidth: 0 }}>
                <div className="col-5 col-md-3">
                  <Select
                    className="prop-field prop-select"
                    default={false}
                    placeholder={t("please_select")}
                    value={item.type}
                    options={NEARBY_TYPES.map((e) => ({ value: e.value, label: t(e.label) }))}
                    onChange={(value) => value && this.setNearby(index, { type: value })}
                  />
                </div>
                <div className="col-7 col-md-6">
                  <input
                    type="text"
                    className="prop-field"
                    placeholder={t("nearby_label_placeholder")}
                    value={item.label}
                    onChange={(e) => this.setNearby(index, { label: e.target.value })}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <div className="pf-suffix">
                    <input
                      type="text"
                      className="prop-field"
                      placeholder="0.00"
                      value={item.distance}
                      onChange={(e) => digits(e.target.value) && this.setNearby(index, { distance: e.target.value })}
                    />
                    <span className="pf-suffix__unit">{t("unit_km_short")}</span>
                  </div>
                </div>
              </div>
              <button type="button" className="pf-doc__x icon" title={t("delete")} onClick={() => this.RemoveNearby(index)}>
                {""}
              </button>
            </div>
          ))}

          {!list.length && (
            <div className="pf-doc pf-doc--empty">
              <span className="pf-doc__icon icon">{""}</span>
              <span className="text-12 text-secondary">{t("nearby_empty")}</span>
            </div>
          )}
        </div>

        <button type="button" className="pf-tagadd mt-2" onClick={this.AddNearby}>
          <span className="icon text-12">{""}</span>
          {t("nearby_add")}
        </button>

        <div className="pf-hint">
          {t("nearby_hint")} · {t("nearby_straight_line")}
        </div>
      </div>
    );
  };

  /* ================================================ render : ตัวกรองการค้นหา */
  /* แก้ค่าในนี้แล้วผลลัพธ์ยังไม่เปลี่ยนจนกว่าจะกดปุ่มค้นหา (หรือกด Enter ในช่องค้นหา) */
  renderFilters = () => {
    const { filter, categories } = this.state;

    return (
      <div className="prop-card prop-in mb-3">
        <div className="prop-card__head py-3">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            <span className="icon me-1 text-12">{""}</span>
            {t("search_filters")}
          </span>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.clearFilters}>
            <span className="icon text-12">{""}</span>
            {t("clear_filters")}
          </button>
        </div>

        <div className="p-4">
          <div className="row g-3">
            <div className="col-xl-5 col-md-6">
              <label className="prop-label">{t("search_project")}</label>
              <div className="position-relative">
                <span className="icon prop-field-icon">{""}</span>
                <input
                  type="text"
                  className="prop-field prop-field--icon"
                  placeholder={t("project_search_placeholder")}
                  value={filter.keyword}
                  onChange={(e) => this.setFilter({ keyword: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Search()}
                />
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <label className="prop-label">{t("property_type")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("project_filter_category")}
                value={filter.category}
                options={[
                  { value: "", label: t("project_filter_category") },
                  ...categories.map((e) => ({ value: e.uid, label: categoryName(e) })),
                ]}
                onChange={(value) => this.setFilter({ category: value || "" })}
              />
            </div>

            {/* ปุ่มค้นหาแชร์บรรทัดเดียวกับช่องสุดท้าย — ชิดขวาสุดของแถว */}
            <div className="col-xl-3 col-md-12 d-flex align-items-end justify-content-md-end">
              <button type="button" className="prop-btn" onClick={this.Search}>
                <span className="icon text-14">{""}</span>
                {t("search")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ==================================================== render : ตารางรายการ */
  renderTable = () => {
    const { items: list, count, active_count } = this.state;

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("project_list_title")}
          </span>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span className="ppl-pill ppl-pill--ghost">
              {num(count)} {t("project_unit")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {num(active_count)} {t("active")}
            </span>
          </div>
        </div>

        <div className="table-responsive mt-3">
          <table className="ppl-table" style={{ minWidth: "1080px" }}>
            <thead>
              <tr>
                <th style={{ width: "260px" }}>{t("project_col_name")}</th>
                <th style={{ width: "220px" }}>{t("property_type")}</th>
                <th>{t("location")}</th>
                <th className="text-center" style={{ width: "110px" }}>{t("project_col_assets")}</th>
                <th style={{ width: "132px" }}>{t("updated")}</th>
                <th className="text-center" style={{ width: "104px" }}>{t("status")}</th>
                <th className="text-center" style={{ width: "112px" }}>{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item) => (
                <tr key={item.uid} className={item.is_active ? "" : "is-off"}>
                  <td>
                    <div className="d-flex align-items-center gap-3">
                      <div className="pty-tile icon" style={{ background: "linear-gradient(150deg,#dfeaf5,#c3d5e8)" }}>
                        {""}
                      </div>
                      <div className="min-w-0">
                        <div className="ppl-name text-truncate">{item.name}</div>
                        <div className="ppl-sub text-truncate">{item.name_en || "-"}</div>
                      </div>
                    </div>
                  </td>

                  <td>
                    {/* ประเภททรัพย์ที่ผูกไว้ — ตัวเดียวกับที่ฟอร์มเพิ่มทรัพย์ใช้กรองโครงการ */}
                    {item.asset_categories?.length ? (
                      <div className="d-flex flex-wrap gap-1">
                        {item.asset_categories.map((category) => (
                          <span key={category.uid} className="ppl-pill ppl-pill--ghost">
                            {category.icon && <span className="icon text-10 me-1">{category.icon}</span>}
                            {categoryName(category)}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="ppl-sub text-secondary">{t("project_no_category")}</span>
                    )}
                  </td>

                  <td>
                    <div className={`pty-desc ${item.address ? "" : "text-secondary"}`}>{item.address || t("project_no_location")}</div>
                    {/* ปักหมุดไว้แล้วหรือยัง — ทรัพย์ที่ดึงทำเลจากโครงการนี้จะได้พิกัดตามไปด้วย */}
                    <div className="ppl-sub">
                      <span className="icon text-10 me-1">{""}</span>
                      {item.latitude !== null && item.longitude !== null
                        ? `${item.latitude}, ${item.longitude}`
                        : t("project_no_pin")}
                    </div>
                  </td>

                  <td className="text-center">
                    <span className="ppl-pill ppl-pill--ghost">{num(item.asset_count)}</span>
                  </td>

                  <td className="text-secondary text-12">{format_date(item.updated_at, "dd mmm yyyy", locale())}</td>

                  <td className="text-center">
                    {/* เปิด/ปิดใช้งาน = การแก้ข้อมูล ป้ายสถานะด้านล่างยังบอกสถานะให้อยู่ */}
                    {can("projects.update") && (
                      <label className="ppl-switch" title={item.is_active ? t("project_disable") : t("project_enable")}>
                        <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                        <span className="ppl-switch__track" />
                      </label>
                    )}
                    <div className={`ppl-sub mt-1 fw-bold ${item.is_active ? "text-success" : ""}`}>
                      {item.is_active ? t("active") : t("inactive")}
                    </div>
                  </td>

                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      {can("projects.update") && (
                        <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                          {""}
                        </button>
                      )}
                      {can("projects.delete") && (
                        <button
                          type="button"
                          className="prop-iconbtn icon"
                          style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                          title={t("delete")}
                          onClick={() => this.Delete(item)}
                        >
                          {""}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}

              {/* ไม่พบข้อมูลเพราะตัวกรอง กับ "ยังไม่มีโครงการเลย" ต้องบอกคนละแบบ
                  อย่างแรกทางออกคือล้างตัวกรอง อย่างหลังคือเพิ่มโครงการใหม่ */}
              {!list.length && (
                <tr>
                  <td colSpan={7}>
                    {this.hasFilter() ? (
                      <div className="prop-empty">
                        <div className="prop-empty__icon icon">{""}</div>
                        <div className="fw-bold text-dark mb-1">{t("no_projects_found")}</div>
                        <div className="text-12">{t("try_adjust_filters")}</div>
                        <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm mt-3" onClick={this.clearFilters}>
                          <span className="icon text-12">{""}</span>
                          {t("clear_all")}
                        </button>
                      </div>
                    ) : (
                      <div className="prop-empty">
                        <div className="prop-empty__icon icon">{""}</div>
                        <div className="fw-bold text-dark mb-1">{t("project_empty_title")}</div>
                        <div className="text-12">{t("project_empty_desc")}</div>
                        {can("projects.create") && (
                          <button type="button" className="prop-btn prop-btn--sm mt-3" onClick={this.OpenCreate}>
                            <span className="icon text-12">{""}</span>
                            {t("project_add")}
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  /* ====================================================== render : แบ่งหน้า */
  renderPagination = () => {
    const { count, page } = this.state;
    if (!count) return null;

    return (
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 text-secondary text-12">
        <div>
          {t("showing")} {(page - 1) * PAGE_SIZE + 1}-{Math.min(page * PAGE_SIZE, count)} {t("of")} {num(count)}{" "}
          {t("project_unit")}
        </div>
        <Pagination
          className="mb-0"
          page={page}
          count={Math.max(1, Math.ceil(count / PAGE_SIZE))}
          showFirstButton={false}
          showLastButton={false}
          onChange={(_, next) => {
            this.Get(next);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        />
      </div>
    );
  };

  /* ============================================ render : modal เพิ่ม/แก้ไข */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;
    const { provinceOptions, districtOptions, subdistrictOptions } = zoneOptions(form.province, form.district);

    return (
      <Modal size="xl" show={modal_form} onHide={this.CloseForm} centered contentClassName="border-0 rounded-4 overflow-visible shadow-lg">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("project_edit") : t("project_add")}</h5>
            <div className="text-secondary text-12">{edit_uid ? t("project_edit_desc") : t("project_add_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          <div className="row g-4">
            {/* ------------------------------------------------ ข้อมูลโครงการ */}
            <div className="col-lg-5">
              <div className="pf-section">
                {this.input("name", "project_name", { required: true, placeholder: "project_name_placeholder" })}
              </div>
              <div className="pf-section">{this.input("name_en", "project_name_en", { placeholder: "project_name_en_placeholder" })}</div>

              <div className="pf-section">
                <label className="prop-label">{t("description")}</label>
                <textarea
                  className="prop-field"
                  rows={3}
                  style={{ height: "auto", paddingTop: "10px" }}
                  maxLength={2000}
                  placeholder={t("project_desc_placeholder")}
                  value={form.description}
                  onChange={(e) => this.setForm({ description: e.target.value })}
                />
              </div>

              {this.renderCategories()}

              <div className="pf-section">
                <label className="prop-label">{t("status")}</label>
                <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                  <label className="ppl-switch">
                    <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                    <span className="ppl-switch__track" />
                  </label>
                  <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                    {form.is_active ? t("active") : t("inactive")}
                  </span>
                </div>
                <div className="pf-hint">{t("project_status_hint")}</div>
              </div>

              <div className="ppl-note">
                <span className="icon">{""}</span>
                <div>{t("project_master_hint")}</div>
              </div>
            </div>

            {/* ---------------------------------------------- ตำแหน่งที่ตั้ง */}
            <div className="col-lg-7">
              <div className="pf-section">
                <label className="prop-label">{t("map")}</label>
                <PlaceSearch
                  value={form.place_search}
                  onChange={(place_search) => this.setForm({ place_search })}
                  onPick={this.PickPlace}
                />
                {this.renderMatchNote()}
                {this.renderMap()}
                <div className="pf-hint">{t("place_search_hint")}</div>
              </div>

              <div className="pf-section">
                <div className="row g-3">
                  <div className="col-md-6">
                    {this.select("province", "province", provinceOptions, { required: true, placeholder: "select_province", onChange: this.setProvince })}
                  </div>
                  <div className="col-md-6">
                    {this.select("district", "district_amphoe", districtOptions, {
                      required: true,
                      placeholder: "select_district",
                      disabled: !form.province,
                      onChange: this.setDistrict,
                    })}
                  </div>
                  <div className="col-md-6">
                    {this.select("subdistrict", "subdistrict_tambon", subdistrictOptions, {
                      required: true,
                      placeholder: "select_subdistrict",
                      disabled: !form.district,
                      onChange: this.setSubdistrict,
                    })}
                  </div>
                  <div className="col-md-6">{this.input("soi", "soi", { placeholder: "soi_placeholder" })}</div>
                  <div className="col-md-6">{this.input("postcode", "postcode", { numeric: true, maxLength: 5 })}</div>
                </div>
              </div>

              <div className="pf-section">
                <div className="pf-subtitle">
                  <span className="icon">{""}</span>
                  {t("coordinates")}
                </div>
                <div className="row g-3">
                  <div className="col-md-6">{this.input("latitude", "label_latitude", { numeric: "signed", placeholder: "latitude_placeholder" })}</div>
                  <div className="col-md-6">{this.input("longitude", "label_longitude", { numeric: "signed", placeholder: "longitude_placeholder" })}</div>
                </div>
                <div className="pf-hint">{t("coordinates_hint")}</div>
              </div>

              {this.renderNearby()}

              <div className="pf-hint mt-2">
                <span className="fw-bold">{t("project_full_address")} :</span> {fullAddress(form) || "-"}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.Save}>
            <span className="icon text-12">{""}</span>
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("projects")}</h3>
              <div className="text-secondary text-14">{t("project_page_desc")}</div>
            </div>
            {can("projects.create") && (
              <button type="button" className="prop-btn" onClick={this.OpenCreate}>
                <span className="icon text-14">{""}</span>
                {t("project_add")}
              </button>
            )}
          </div>

          {this.renderFilters()}
          {this.renderTable()}
          {this.renderPagination()}
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
